/**
 * @const AccountCapability
 */

export const SWEEP_TRANSFER_CAPABLE = '/account/sweeps/transfer/out';
export const SWEEPS_CAPABLE = '/account/sweeps';
export const ALERTS_CAPABLE = '/account/alerts';
export const PROJECTION_CAPABLE = '/account/projections';
export const LIMITED_READ = '/account/read/limited';
export const TRANSACTIONS_READ = '/account/transactions/read';
export const POTS_CAPABLE = '/account/pots';
export const INSIGHT_CAROUSEL_VIEW = '/account/insight_carousel/view';
export const ENRICHED = '/accounts/enriched_transactions/read';
